// extracted by mini-css-extract-plugin
export var backdropBlur = "_jv-0";
export var contentCard = "_jv-5";
export var frame = "_jv-2";
export var image = "_jv-4";
export var imagePane = "_jv-3";
export var modal = "_jv-1";